/* Keep the landing-page zoom synced after page load with debouncing. */
(function () {
  if (window.__mainContentZoomInit) return;
  window.__mainContentZoomInit = true;

  var zoomConfig = window.__mainContentZoomConfig || {};

  var DESKTOP_DESIGN_WIDTH = Number(zoomConfig.designWidth) || 1920;
  var MOBILE_DESIGN_WIDTH = Number(zoomConfig.mobileDesignWidth) || 375;
  var MOBILE_MAX = Number.isFinite(Number(zoomConfig.mobileMax))
    ? Number(zoomConfig.mobileMax)
    : 767;
  var DEBOUNCE_MS = Number.isFinite(Number(zoomConfig.debounceMs))
    ? Number(zoomConfig.debounceMs)
    : 120;

  var rafId = null;
  var debounceTimer = null;

  function getViewportWidth() {
    return document.documentElement.clientWidth || window.innerWidth || 0;
  }

  function getDesignWidth(viewportWidth) {
    return viewportWidth <= MOBILE_MAX
      ? MOBILE_DESIGN_WIDTH
      : DESKTOP_DESIGN_WIDTH;
  }

  function clearMainContentZoom() {
    document.documentElement.style.removeProperty('--main-content-zoom');
    document.documentElement.classList.remove('has-main-content-zoom');
    document.documentElement.classList.remove('has-main-content-zoom-mobile');
    document.documentElement.classList.remove('has-main-content-zoom-desktop');
  }

  function applyMainContentZoom() {
    var vw = getViewportWidth();

    if (!vw || vw <= 0) {
      clearMainContentZoom();
      return;
    }

    var designWidth = getDesignWidth(vw);

    if (!designWidth || designWidth <= 0) {
      clearMainContentZoom();
      return;
    }

    var zoom = vw / designWidth;

    /*
      保留足够精度，避免 resize 时产生大量无意义的小数变化。
      PC:     viewport / 1920
      Mobile: viewport / 375
    */
    zoom = Math.round(zoom * 1000000) / 1000000;

    document.documentElement.style.setProperty(
      '--main-content-zoom',
      String(zoom)
    );

    document.documentElement.classList.add('has-main-content-zoom');

    if (vw <= MOBILE_MAX) {
      document.documentElement.classList.add('has-main-content-zoom-mobile');
      document.documentElement.classList.remove('has-main-content-zoom-desktop');
    } else {
      document.documentElement.classList.add('has-main-content-zoom-desktop');
      document.documentElement.classList.remove('has-main-content-zoom-mobile');
    }
  }

  function scheduleApply(delay) {
    var wait = typeof delay === 'number' ? delay : DEBOUNCE_MS;

    if (debounceTimer !== null) {
      window.clearTimeout(debounceTimer);
    }

    debounceTimer = window.setTimeout(function () {
      debounceTimer = null;

      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }

      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        applyMainContentZoom();
      });
    }, wait);
  }

  window.__applyMainContentZoom = applyMainContentZoom;
  window.__scheduleMainContentZoom = scheduleApply;

  window.addEventListener(
    'load',
    function () {
      scheduleApply(0);
    },
    { once: true }
  );

  window.addEventListener('pageshow', function () {
    scheduleApply(0);
  });

  window.addEventListener(
    'resize',
    function () {
      scheduleApply();
    },
    { passive: true }
  );

  window.addEventListener(
    'orientationchange',
    function () {
      scheduleApply(50);
    },
    { passive: true }
  );

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    scheduleApply(0);
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleApply(0);
      },
      { once: true }
    );
  }
})();
